import React, { useMemo } from 'react'
import styled from '@emotion/styled'

import UpcomingEvents from './UpcomingEvents'
import MyWork from './MyWork'
import MyApp from './MyApp'
import ProfileCard from '../../components/ProfileCard'
import News from './News'
import LifeStyle from './LifeStyle'
import { mobile, tablet, useScreen } from '../../utils/responsive-helper'
import Welfare from './Welfare'
import { useGetEnrollmentPeriod } from '../../services/enrollment/enrollment-query'
import dayjs from 'dayjs'

const Layout = styled.div`
  padding-bottom: 40px;
  > * {
    margin-top: 24px;
  }
  .profile-card {
    margin-right: 24px;
    ${mobile} {
      margin-right: unset;
      margin-bottom: 16px;
    }
  }
`
const FlexRow = styled.div`
  display: flex;
  ${mobile} {
    flex-direction: column;
  }
`
const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  > *:not(:first-of-type) {
    margin-top: 24px;
  }
  ${tablet} {
    max-width: calc(100% - 324px);
  }
  ${mobile} {
    max-width: unset;
  }
`

const Home = () => {
  const { isMobile } = useScreen()
  const { data: enrollmentPeriod } = useGetEnrollmentPeriod()
  const { startDate, endDate } = enrollmentPeriod || {}

  const canEditEnrollment = useMemo(() => {
    const today = dayjs().endOf('day')
    const _startDate = dayjs(startDate).endOf('day')
    const _endDate = dayjs(endDate).endOf('day')
    if (_startDate.isValid() && _endDate.isValid()) {
      return today.isAfter(_startDate) && today.isBefore(_endDate)
    } else {
      return false
    }
  }, [endDate, startDate])
  return (
    <Layout>
      {!isMobile && canEditEnrollment && <Welfare />}
      <FlexRow style={{ marginTop: 22 }}>
        <ProfileCard />
        <FlexColumn>
          {/* <MyWork /> */}
          <MyApp />
        </FlexColumn>
      </FlexRow>
      {/* <UpcomingEvents /> */}
      {/* <News /> */}
      <LifeStyle />
    </Layout>
  )
}

export default Home
